import { render } from "./RootItem.vue?vue&type=template&id=40ba5e99"
import script from "./RootItem.vue?vue&type=script&lang=js"
export * from "./RootItem.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__